module.exports = __webpack_public_path__ + "animation-c16bc6c7771aab7ef8eb5169be7f9914e461374c97bbc7bfa883bc6cd2adc76a.gif";